import * as React from "react";

import classNames from "classnames";

import GenS3FileUploader from "../Gen/S3MediaAssetUploader";

interface MediaAssetNewWebkitProps {
  document_id: number;
}

interface MediaAssetNewWebkitState {
  progressPercent?: number;
}

export default class MediaAssetNewWebkit extends React.Component<MediaAssetNewWebkitProps, MediaAssetNewWebkitState> {
  constructor(props: MediaAssetNewWebkitProps) {
    super(props);

    this.state = {};
  }

  onUploadProgress(progressEvent: number) {
    this.setState({progressPercent: progressEvent});
  }

  onUploadError(error: string) {
    console.log("ERROR:", error);
    alert("Error Uploading");
  }

  onUploadFinish() {
    const {
      document_id,
    } = this.props;

    Turbo.visit(`/documents/${document_id}/hipaa_releases/new`);
  }

  render() {
    const {
      document_id,
    } = this.props;

    const {
      progressPercent,
    } = this.state;

    const hasProgress = typeof progressPercent === "number";

    return (
      <div>
        <label className={classNames("button", "bg-sky-600 hover:bg-sky-500", {disabled: hasProgress})} style={{width: "100%"}}>
          {hasProgress ? "Uploading Video" : "Capture Video"}
          <GenS3FileUploader
            id="video_upload_button"
            signingUrl="/media_assets/signed_url"
            accept="video/mp4,video/*"
            onProgress={this.onUploadProgress}
            onError={this.onUploadError}
            onFinish={this.onUploadFinish.bind(this)}
            documentId={document_id}
            mediaType="video"
          />
        </label>
        {typeof progressPercent === "number" && (
          <div className="progress progress-striped active">
            <div className="bar" style={{width: `${progressPercent * 0.95}%`}} />
          </div>
        )}
      </div>
    );
  }
}
